export default function FormActions({
  children,
  className = "",
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={`mt-6 flex justify-end gap-4 ${className}`}
    >
      {children}
    </div>
  );
}